import { FC } from "react";

import { Box, Row, Tooltip, TooltipProps, BoxProps } from "@hightouch/htui";

import { Link } from "src/router";

import { useContentFits } from "src/hooks/use-content-fits";

type LinkWithTooltipProps = BoxProps &
  Omit<TooltipProps, "message"> & {
    message?: string;
  } & {
    href: string;
    isExternal?: boolean;
  };

export const LinkWithTooltip: FC<Readonly<LinkWithTooltipProps>> = ({
  children,
  isDisabled = false,
  keyboardShortcut,
  message,
  placement,
  href,
  ...props
}) => {
  const { contentFits, ref } = useContentFits<HTMLAnchorElement>();

  return (
    <>
      {/* Remove the `width: max-content` in the span to make ellipsis show */}
      <Row
        display="flex"
        alignItems="center"
        overflow="hidden"
        sx={{
          span: { width: "100%", whiteSpace: "nowrap" },
          a: {
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      >
        <Tooltip
          message={message ?? String(children)}
          isDisabled={contentFits || isDisabled}
          keyboardShortcut={keyboardShortcut}
          placement={placement}
        >
          <Box as={Link} href={href} ref={ref} {...props}>
            {children}
          </Box>
        </Tooltip>
      </Row>
    </>
  );
};
